import cn from "../../lib/classnames";
import DownloadButton from "../DownloadButton";
import React from "react";
import styles from "./ElectronicCommunicationsAgreementContent.module.css";

const strings = {
    title: "ELECTRONIC COMMUNICATIONS AGREEMENT",
    intro:
        "You consent and agree that 1st Financial Bank USA (“Bank,” “we,” or “us”) may on the terms and conditions set forth in this Electronic Communications Agreement (“Agreement”) provide to you each disclosure, notice, agreement, fee schedule, statement, record, document and other information in connection with the account that you hold with us or for which you are designated as an authorized user (“Account”), including legally required notices and communications which you may otherwise have the right to receive in paper form, in electronic form (e.g., by email, our website or mobile message) (“Electronic Communication”), except as otherwise specified in this Agreement.",
    name1: "Documents and Communications Covered",
    body1:
        "Your consent to receive Electronic Communications includes this Agreement and other disclosures and communications we provide to you in connection with your Account, such as (1) billing statements; (2) billing rights statements; (3) terms and conditions and any notices about a change in terms and conditions; (4) error resolution policies and notices; (5) responses to claims filed in connection with your Account; and (6) legal and regulatory disclosures and communications associated with your Account and any related products and services.",

    name2: "Method of Delivery",
    body2a:
        "We may deliver Electronic Communications to you by any lawfully permitted electronic manner, including, posting them on our website, by email to the primary email address you provide to us in connection with your Account (“Delivery Email Address”), by mobile message, or any combination of these means. Notice that your monthly billing statement is available to view, download and print will be delivered to your Delivery Email Address (“Electronic Delivery Notice”).",
    body2b:
        "We reserve the right to send paper communications to you at any time in our sole discretion. Events that may trigger our sending you paper communications include: (1) if your Delivery Email Address does not accept a communication we send to you at that address, including a Electronic Delivery Notice; (2) if the electronic system relating to a product or service we offer that requires us to send notices to you is not yet enabled to deliver electronic messages; and (3) in the event we believe it is necessary to communicate with you regarding potential fraud or other matters relating to your Account.",
    body2c:
        "In the event that an Electronic Delivery Notice is undeliverable or undelivered for any reason or if you choose not to view it, you agree that such statement will be deemed to have been delivered by us for all purposes under either state or federal law.",

    name3: "Delivery Email Address",
    body3a:
        "You represent that your Delivery Email Address belongs to you or to a person who has authority to act on your behalf in connection with your Account.",
    body3b:
        'You understand and agree that it is your responsibility to promptly notify us of any change to your Delivery Email Address. You may update your Delivery Email Address by calling us at 1- 800-733-1732 or through our website or mobile under “Account Information".',
    body3c:
        "You understand and agree that our ability to deliver Electronic Communications to you by email is dependent on the validity of your Delivery Email Address or our receipt of notice of a change to it.",

    name4: "Rejection of Electronic Communication or Electronic Delivery Notice",
    body4a:
        "If we attempt to send an Electronic Communication or Electronic Delivery Notice to you and it is returned as undeliverable, we are under no obligation to make any attempt to resend it if we determine that your Delivery Email Address, or any other email address you have provided to us in connection with your Account, is defective. We may treat an email address as defective if it is invalid, inactive or otherwise non-functioning and where additional attempts to send a communication or notice to that address would be futile.",
    body4b:
        "You understand and agree that if any Electronic Communication or Electronic Delivery Notice that we send to you is rejected for any reason, your consent to receive Electronic Communications will automatically be withdrawn. In such case, we will send you notice by regular mail or other permissible means that your consent has been withdrawn.",

    name5: "Privacy Notice",
    body5:
        "You may access our Privacy Notice at any time through our website or mobile app under the “Privacy” tab.",

    name6: "Withdrawing Your Consent",
    body6a:
        "You may withdraw your consent to receive Electronic Communications any time by calling us at 1-800-733-1732 or through our website or mobile app by checking the “Withdraw consent to receive electronic communications” check box. The checkbox is displayed under “Legal Disclosures” under the “Electronic Communications Consent/Withdrawal” tab.",
    body6b:
        "Any withdrawal of your consent to receive Electronic Communications will be effective only after we have a reasonable period of time to process your withdrawal. It may take up to two billing cycles after we receive your withdrawal of consent before you receive billing statements in paper form. The withdrawal of consent will not affect the legal validity and enforceability of prior Electronic Communications. At our option, we will treat your provision of an invalid email address, or the subsequent malfunction of a previously valid email address, as a withdrawal of your consent to receive Electronic Communications. We will not impose any fee to process the withdrawal of your consent to receive Electronic Communications.",

    name7: "Obtaining Paper Copies",
    body7a:
        "Following our receipt of your consent to receive Electronic Communications, we will no longer provide you with a paper copy of any Electronic Communication, unless you request a paper copy or we otherwise deem it appropriate to do so. You can obtain a paper copy of an Electronic Communication by printing it yourself or by requesting that we send you a paper copy. For any paper copy you request, you may be charged $3. A request for a paper copy will not be considered a withdrawal of consent to receive Electronic Communications unless you expressly withdraw your consent in such request.",
    body7b:
        "We reserve the right, but have no obligation, to provide a paper copy of any communication that you have consented to receive electronically.",

    name8: "System Requirements",
    body8:
        "In order to receive, access and retain Electronic Communications, you must have access to a computing, mobile or other communications device with Internet access and a browser that supports 256-bit encryption (e.g., Microsoft® Edge®, Apple® Safari®, Firefox®, or Google® Chrome®) and a printer if you wish to print them and electronic storage if you wish to retain them. If you are unable to receive, access or retain any Electronic Communications, check to make sure you meet the system requirements listed above or call us at 1-800-733-1732 for assistance.",

    name9: "Changes to Hardware or Software Requirements",
    body9:
        "We may change the hardware and/or software requirements needed to receive Electronic Communications from time to time. If a change in the hardware and/or software requirements creates a material risk that you will not be able to receive Electronic Communications, we will provide you a statement of the revised requirements and you will have the right to withdraw your consent at that time. If you do not withdraw your consent, you will need to reaffirm it at that time.",

    name10: "Limitation of Liability",
    body10a:
        "YOU UNDERSTAND AND AGREE THAT WE MAKE NO REPRESENTATIONS AND WARRANTIES THAT WE WILL BE ABLE TO PROVIDE ELECTRONIC COMMUNICATIONS WITHOUT INTERRUPTION OR THAT SUCH COMMUNICATIONS WILL BE PROVIDED WITHOUT ANY ERRORS. THE SERVICE THROUGH WHICH WE PROVIDE ELECTRONIC COMMUNICATIONS (“SERVICE”) IS PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS AND WE MAKE NO REPRESENTATIONS OR WARRANTIES RELATING TO THE SERVICE INCLUDING, WITHOUT LIMITATION, ITS PERFORMANCE AND AVAILABILITY, ANY EXPRESS OR IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE OR NON- INFRINGEMENT OF ANY THIRD PARTY RIGHT. YOU UNDERSTAND AND AGREE THAT YOUR SOLE AND EXCLUSIVE REMEDY FOR ANY FAILURE OR NON-PERFORMANCE OF THE SERVICE SHALL BE FOR US TO MAKE REASONABLE EFFORTS TO ENABLE YOU TO MAKE PROPER USE OF THE SERVICE.",
    body10b:
        "YOU ALSO UNDERSTAND AND AGREE THAT IN NO EVENT SHALL WE OR ANY OF OUR OFFICERS, DIRECTORS, SUBSIDIARIES, AFFILIATES, AGENTS, LICENSORS, OR THIRD PARTY SERVICE PROVIDERS BE LIABLE FOR ANY CONSEQUENTIAL, INDIRECT, INCIDENTAL, SPECIAL OR PUNITIVE DAMAGES, WHETHER IN AN ACTION UNDER CONTRACT, NEGLIGENCE OR ANY OTHER THEORY, ARISING OUT OF OR IN CONNECTION WITH THIS AGREEMENT, THE SERVICE, OR THE INABILITY TO USE THE SERVICE, EVEN IF WE OR ANY RELATED PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. OUR AGGREGATE LIABILITY UNDER THIS AGREEMENT SHALL NOT EXCEED ONE THOUSAND DOLLARS ($1,000). IN ANY EVENT, AN ACTION OR PROCEEDING BROUGHT BY YOU TO ENFORCE ANY OBLIGATION, DUTY OR RIGHT ARISING UNDER THIS AGREEMENT MUST BE COMMENCED WITHIN ONE (1) YEAR FROM THE DATE THAT SUCH CAUSE OF ACTION ACCRUES.",

    name11: "Indemnity",
    body11:
        "You agree to indemnify, defend, and hold us, our affiliates, officers, directors, employees, consultants, agents, service providers and licensors free from any and all third party claims, liability, damages and/or costs (including but not limited to reasonable attorneys' fees) arising from (1) any fraud, manipulation, or other breach of this Agreement; (2) any third party claim, action, or allegation brought against us arising out of or relating to a dispute with us over the terms and conditions of this Agreement; (3) any violation of any laws or regulations or the rights of a third party; or (4) the use of the Service by any third party. We reserve the right at our own expense to assume the exclusive defense and control of any matter otherwise subject to indemnification hereunder by you, in which event you will cooperate with us in asserting any available defenses. You will not settle any action or claims on our behalf without our prior written consent.",

    name12: "Amendments",
    body12a:
        "You understand and agree that we may amend the terms and conditions of this Agreement without prior notice unless required by applicable law. If we choose to notify you of an amendment or are required to do so by law, we may ask that you agree to an amended version of this Agreement.",

    name13: "Acceptance and Consent",
    body13a: "By consenting to this Agreement, you agree that:",
    body13b:
        "You have read, understand and consent to the terms and conditions of this Agreement, including to the delivery of Electronic Communications;",
    body13c:
        "You are authorized to consent to this Agreement, including to the delivery of Electronic Communications;",
    body13d:
        "You are able to download and review files in HTML or PDF format, have Internet access, and can send and receive emails with links to websites;",
    body13e:
        "Certain Electronic Communications may be delivered to you in paper form and in the future some or all of these Electronic Communications may be made available for you to view electronically in accordance with this Agreement; and",
    body13f:
        "Your consent to receive Electronic Communications does not automatically expire and will continue unless and until you withdraw it in the manner described in this Agreement.",
};

enum BodyType {
    Paragraph,
    List,
}

type BodyParagraph = {
    type: BodyType.Paragraph;
    content: string;
};

type BodyList = {
    type: BodyType.List;
    content: string[];
    important?: boolean;
};

type Section = {
    name: string;
    body: (BodyParagraph | BodyList)[];
};

const SECTIONS: Section[] = [
    {name: strings.name1, body: [{type: BodyType.Paragraph, content: strings.body1}]},
    {
        name: strings.name2,
        body: [
            {type: BodyType.Paragraph, content: strings.body2a},
            {type: BodyType.Paragraph, content: strings.body2b},
            {type: BodyType.Paragraph, content: strings.body2c},
        ],
    },

    {
        name: strings.name3,
        body: [
            {type: BodyType.Paragraph, content: strings.body3a},
            {type: BodyType.Paragraph, content: strings.body3b},
            {type: BodyType.Paragraph, content: strings.body3c},
        ],
    },
    {
        name: strings.name4,
        body: [
            {type: BodyType.Paragraph, content: strings.body4a},
            {type: BodyType.Paragraph, content: strings.body4b},
        ],
    },
    {name: strings.name5, body: [{type: BodyType.Paragraph, content: strings.body5}]},
    {
        name: strings.name6,
        body: [
            {type: BodyType.Paragraph, content: strings.body6a},
            {type: BodyType.Paragraph, content: strings.body6b},
        ],
    },
    {
        name: strings.name7,
        body: [
            {type: BodyType.Paragraph, content: strings.body7a},
            {type: BodyType.Paragraph, content: strings.body7b},
        ],
    },
    {
        name: strings.name8,
        body: [{type: BodyType.Paragraph, content: strings.body8}],
    },
    {
        name: strings.name9,
        body: [{type: BodyType.Paragraph, content: strings.body9}],
    },
    {
        name: strings.name10,
        body: [
            {type: BodyType.Paragraph, content: strings.body10a},
            {type: BodyType.Paragraph, content: strings.body10b},
        ],
    },
    {
        name: strings.name11,
        body: [{type: BodyType.Paragraph, content: strings.body11}],
    },
    {
        name: strings.name12,
        body: [{type: BodyType.Paragraph, content: strings.body12a}],
    },
    {
        name: strings.name13,
        body: [
            {type: BodyType.Paragraph, content: strings.body13a},
            {
                type: BodyType.List,
                content: [
                    strings.body13b,
                    strings.body13c,
                    strings.body13d,
                    strings.body13e,
                    strings.body13f,
                ],
                important: true,
            },
        ],
    },
];

export default function ElectronicCommunicationsAgreementContent() {
    return (
        <>
            <div className={styles.title}>{strings.title}</div>
            <div className={styles.section}>{strings.intro}</div>
            {SECTIONS.map((s, i) => (
                <div key={s.name} className={styles.section}>
                    <div className={styles.sectionName}>
                        {i + 1}. {s.name}
                    </div>
                    {s.body.map((b, j) => {
                        if (b.type === BodyType.Paragraph) {
                            return (
                                <div className={styles.sectionParagraph} key={j}>
                                    {b.content}
                                </div>
                            );
                        } else {
                            return (
                                <div
                                    key={j}
                                    className={cn(
                                        styles.list,
                                        b.important ? styles.listImportant : undefined,
                                    )}
                                >
                                    {b.content.map((item, k) => (
                                        <div key={k} className={styles.listItem}>
                                            <div>{item}</div>
                                        </div>
                                    ))}
                                </div>
                            );
                        }
                    })}
                </div>
            ))}
            <DownloadButton
                className={styles.download}
                url={`${process.env.REACT_APP_BASE_PATH}/Electronic_Agreement.pdf`}
            />
        </>
    );
}
